const fonts = {
    fontFamily: 'Montserrat, sans-serif',
    fontWeightLight: '200',
    fontWeightRegular: '400',
    fontWeightBold: '900',
}

export default fonts